<template>
  <div>
      <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start; flex-wrap: wrap;">

        <div             
            v-for="(data, index) in image_list"
            :key="index"
            style="display: flex; 
            flex-direction: column; 
            justify-content: center; 
            align-items: center;
            margin: 20px;">
            <div style="width: 200px; height: 200px;">
                <UploadFile 
                    @uploaded="addNewImage(index, $event)"
                    :image_path="data"
                    :image_width="200"
                    :file_dialog_id="'work_order_photo_'+index"
                    :hide_upload="data.length>5"
                    :button_style="'width: 100px; top: 5px; position: relative;'"
                />
            </div>
            
            <el-button @click="removeImage(index)" v-if="data.length>5" size="small" type="danger" style="top: 5px; position: relative;">
                Remove
            </el-button>            
        </div>
        
      </div>
  </div>
</template>

<script>
export default {
    props: ['image_list'],
    methods: {
        addNewImage(index, $event) {
            this.image_list[index] = $event
            this.image_list.push("")
        },
        removeImage(index) {
            this.$confirm('Are you sure to remove?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.image_list.splice(index, 1)
            }).catch(() => {
                    
            });
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/ImageList.vue